"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GoogleIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.4 5.08a3.722 3.722 0 00-2.26-.75c-1.611 0-2.968.965-3.444 2.308a3.15 3.15 0 00-.002 2.11l-2.065 1.468a5.363 5.363 0 010-5.044C3.629 3.29 5.714 2 8.14 2a6.39 6.39 0 014.047 1.424L10.4 5.08z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.14 11.06c-1.611 0-2.968-.966-3.444-2.308l-2.067 1.465c.999 1.884 3.084 3.173 5.51 3.173 1.498 0 2.928-.494 4-1.42l-1.96-1.408c-.554.324-1.251.498-2.04.498zm5.72-4.4A4.4 4.4 0 0114 7.694c0 1.856-.733 3.304-1.86 4.275l-1.962-1.408c.642-.375 1.09-.952 1.255-1.702H8.14v-2.2h5.72z"
  })))
});
GoogleIcon.displayName = 'GoogleIcon';
var _default = exports.default = GoogleIcon;